import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Zeitersparnis',
      desc: 'Kein endloses Suchen – alle Links an einem Ort. Finde in Minuten, wonach du sonst stundenlang suchen müsstest.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20clock%20concept%20with%20elegant%20time%20management%20visual%20on%20warm%20cream%20background%2C%20soft%20diffused%20natural%20light%2C%20productivity%20aesthetic%2C%20clean%20beige%20and%20warm%20neutral%20tones%2C%20editorial%20quality%2C%20no%20people%2C%20sophisticated%20abstract%20composition%20representing%20efficiency&width=600&height=400&seq=feat-time&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Geprüfte Qualität',
      desc: 'Nur Produkte mit guten Bewertungen werden aufgenommen. Wir prüfen jede Empfehlung sorgfältig.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20quality%20assurance%20concept%20with%20magnifying%20glass%20over%20elegant%20fashion%20fabric%20swatches%20on%20cream%20marble%20surface%2C%20soft%20natural%20studio%20lighting%2C%20minimalist%20QC%20aesthetic%2C%20warm%20beige%20and%20gold%20tones%2C%20editorial%20product%20photography%2C%20no%20people%2C%20refined%20composition&width=600&height=400&seq=feat-quality&orientation=landscape',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Wöchentliche Updates',
      desc: 'Spreadsheets werden regelmäßig aktualisiert. Neue Produkte kommen hinzu, nicht verfügbare werden entfernt.',
      image: 'https://readdy.ai/api/search-image?query=Fresh%20modern%20desk%20with%20calendar%20showing%20weekly%20schedule%20and%20curated%20fashion%20items%20nearby%2C%20soft%20morning%20sunlight%2C%20minimalist%20productivity%20aesthetic%2C%20warm%20cream%20and%20beige%20tones%2C%20editorial%20lifestyle%20photography%2C%20no%20people%2C%20organized%20inspiring%20workspace&width=600&height=400&seq=feat-updates&orientation=landscape',
    },
    {
      icon: 'ri-global-line',
      title: 'DACH-Optimiert',
      desc: 'Speziell für Deutschland, Österreich und Schweiz. Alle Versand- und Zollinfos auf einen Blick.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20world%20map%20concept%20with%20subtle%20European%20highlights%20on%20cream%20textured%20background%2C%20soft%20ambient%20lighting%2C%20sophisticated%20global%20commerce%20aesthetic%2C%20warm%20beige%20and%20neutral%20tones%2C%20no%20people%2C%20refined%20abstract%20design%20representing%20international%20reach&width=600&height=400&seq=feat-dach&orientation=landscape',
    },
  ];

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Warum OOPBuy Spreadsheet?
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            Entdecke die Vorteile, die dich beim Einkauf mit OOPBuy Spreadsheets erwarten.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {features.map((feat, idx) => (
            <div key={idx} className="group flex flex-col sm:flex-row gap-4 p-5 bg-background-50 border border-background-200/80 rounded-xl hover:border-primary-200 transition-all">
              <div className="w-full sm:w-36 h-28 overflow-hidden rounded-lg flex-shrink-0">
                <img
                  src={feat.image}
                  alt={feat.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2.5 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-50 text-foreground-500 group-hover:bg-primary-50 group-hover:text-primary-500 transition-colors">
                    <i className={`${feat.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-semibold text-foreground-800 text-sm">{feat.title}</h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <div className="bg-background-100 rounded-xl p-6 md:p-8">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 text-center mb-6">
              So funktioniert&apos;s
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  step: '1',
                  title: 'Kategorie wählen',
                  desc: 'Wähle aus 14 Kategorien die passende für dich aus.',
                  icon: 'ri-list-check',
                },
                {
                  step: '2',
                  title: 'Spreadsheet öffnen',
                  desc: 'Klicke auf die Kategorie und entdecke hunderte Produkte.',
                  icon: 'ri-file-text-line',
                },
                {
                  step: '3',
                  title: 'Produkt bestellen',
                  desc: 'Finde dein Wunschprodukt und bestelle direkt auf kaspreadsheet.com.',
                  icon: 'ri-shopping-bag-3-line',
                },
              ].map((s, idx) => (
                <div key={idx} className="text-center">
                  <span className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-primary-500 text-white text-sm font-bold mb-3">
                    {s.step}
                  </span>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-1">{s.title}</h4>
                  <p className="text-xs text-foreground-500">{s.desc}</p>
                </div>
              ))}
            </div>
            <div className="text-center mt-6">
              <Link
                to="/artikel/oopbuy-einsteiger-guide"
                className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
              >
                <span>Zum Einsteiger-Guide</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}